import './DefaultContentWrapper.scss';

import { bem } from 'mission-control-common-components';

type Props = {
  children: React.ReactNode;
};

const [block, element] = bem('custom-pacing-schedule-content');

const DefaultContentWrapper = ({ children }: Props): React.JSX.Element => {
  return (
    <div className={block()}>
      <div className={element('children-wrapper')} data-testid="custom-pacing-schedule-content">
        {children}
      </div>
    </div>
  );
};

export default DefaultContentWrapper;
